import * as firebase from "firebase";
const config = {
  apiKey: "AIzaSyA-M-Ksxj1mF0UkW-jDsGUCe9QN6lu0Ncs",
  authDomain: "beast-news.firebaseapp.com",
  databaseURL: "https://beast-news.firebaseio.com",
  projectId: "beast-news",
  storageBucket: "beast-news.appspot.com",
  messagingSenderId: "979010480834",
  appId: "1:979010480834:web:d412a61c0b2badbef1295b",
  measurementId: "G-KV0RNMJX55",
};

firebase.initializeApp(config);

const errorHandling = (error) => {
  if (
    error.code === "permission-denied" &&
    error.message === "Missing or insufficient permissions."
  ) {
    localStorage.clear();
    logoutUser();
  }
  console.log(
    "=====================  Error Handling ============>>>>>>>>>",
    error
  );
};

const articleRef = firebase.firestore().collection("Articles");
// .orderBy('createdAt', 'desc');
const latestArticleRef = firebase.firestore().collection("LatestArticles");
const electionDetailsRef = firebase.firestore().collection("electionDetails");
const unitedStateCollectionRef = firebase.firestore().collection("usStateCollection");
const appThemeConfigRef = firebase.firestore().collection("appThemeConfig");

// const messaging = firebase.messaging()
const liveStreamRef = firebase
  .firestore()
  .collection("LiveStream")
  .doc("LiveStream");

const filtersArray = firebase.firestore().collection("Filters").doc("Filters");

const featuredId = firebase
  .firestore()
  .collection("FeaturedStatus")
  .doc("FeaturedStatus");

const articleSliderRef = firebase
  .firestore()
  .collection("Slider")
  .doc("ArticleSlider");
const newsSliderRef = firebase
  .firestore()
  .collection("Slider")
  .doc("NewsSlider");

const authorsRef = firebase.firestore().collection("Authors");

export const addArticle = (article) => articleRef.add(article);
export const addLatestArticle = (article) => latestArticleRef.add(article);
export const addElectionDetails = (electionDetails) => electionDetailsRef.add(electionDetails);
export const addUSStateCollection = (USStateDetails) => unitedStateCollectionRef.add(USStateDetails); 
export const addAppThemConfig = (appThemConfig) => appThemeConfigRef.add(appThemConfig);

export const addFeaturedId = (ids, featured, news) =>
  featuredId.update({ FeaturedId: ids, featured: featured, news: news });
export const getArticles = articleRef.get();
export const getLatestArticles = latestArticleRef.get();
export const getElectionDetails = electionDetailsRef.get();
export const getUSStateCollection = unitedStateCollectionRef.get();

export const updateArticleFieldsWithImage = (deckID, article) =>
  articleRef.doc(deckID).update(article);
export const updateArticleFields = (deckID, article) =>
  articleRef.doc(deckID).update(article);

// update Latest Article
export const updateLatestArticleFieldsWithImage = (articleID, article) =>
  latestArticleRef.doc(articleID).update(article);
export const updateLatestArticleFields = (articleID, article) =>
  latestArticleRef.doc(articleID).update(article);

export const updateElectionDetails = (electionDetailID, electionDetails) => 
electionDetailsRef.doc(electionDetailID).update(electionDetails);

export const updateUSState = (USStateID, USStateDetails) => 
  unitedStateCollectionRef.doc(USStateID).update(USStateDetails);

export const updateAppThemConfig = (appThemConfigID, appThemConfig) => 
  appThemeConfigRef.doc(appThemConfigID).update(appThemConfig);

export const deleteElectionDetailsUpdate = (electionDetailsID) => electionDetailsRef
  .doc(electionDetailsID)
  .delete()
  .catch((error) => {
    console.log(
      "===================== deleteAuthor Error ============>>>>>>>>>",
      error
    );
    errorHandling(error);
    return error;
  });

export const deleteLatestArticle = (articleID) => {
  return latestArticleRef
    .doc(articleID)
    .delete()
    .catch((error) => {
      console.log(
        "===================== deleteLatest Article Error ============>>>>>>>>>",
        error
      );
      errorHandling(error);
      return error;
    });
};

export const deleteAppThemConfig = (appThemConfigID) => {
  return appThemeConfigRef
    .doc(appThemConfigID)
    .delete()
    .catch((error) => {
      console.log(
        "===================== delete App Them Config Error ============>>>>>>>>>",
        error
      );
      errorHandling(error);
      return error;
    });
};

export const getLiveStream = liveStreamRef.get();
export const getFilterList = filtersArray.get();
export const getFeaturedId = featuredId.get();
export const getAppThemConfig = appThemeConfigRef.get();

export const setLiveStream = (isLiveStream, videoUrl, title) =>
  liveStreamRef.update({ isLiveStream, videoUrl, title });

export const getArticleSliders = articleSliderRef.get();
export const updateArticleSliders = (sliders) =>
  articleSliderRef.update({ sliders: sliders });

export const getNewsSliders = newsSliderRef.get();
export const updateNewsSliders = (sliders) =>
  newsSliderRef.update({ sliders: sliders });

export const getAppUsers = firebase.firestore().collection("Users").get();
export const getAuthors = authorsRef.get();

export const addAuthor = (uid, author) =>
  // console.log('author is>>>', author)
  // authorsRef.add(author).catch((err) => {
  //   console.log("============== getAuthors Error ==========>>>>", err);
  // });

  authorsRef.doc(uid).set(author).catch((err) => {
    console.log("============== getAuthors Error ==========>>>>", err);
  });

export const deleteAuthor = (authorID) =>
  authorsRef
    .doc(authorID)
    .delete()
    .catch((error) => {
      console.log(
        "===================== deleteAuthor Error ============>>>>>>>>>",
        error
      );
      errorHandling(error);
      return error;
    });

export const deckRef = firebase.firestore().collection("Articles");
export const getDeck = deckRef.get().catch((error) => {
  return error;
});

export const updateDeckNameImage = (deckID, article) =>
  articleRef
    .doc(deckID)
    .update(article)
    .catch((error) => {
      console.log(
        "===================== updateDeckNameImage Error ============>>>>>>>>>",
        error
      );
      errorHandling(error);
      return error;
    });

export const updateDeckName = (deckID, article) =>
  articleRef
    .doc(deckID)
    .update(article)
    .catch((error) => {
      console.log(
        "===================== updateDeckName Error ============>>>>>>>>>",
        error
      );
      errorHandling(error);
      return error;
    });

export const addDeck = (deck) =>
  deckRef.add(deck).catch((error) => {
    console.log(
      "===================== addDeck Error ============>>>>>>>>>",
      error
    );
    errorHandling(error);
    return error;
  });

export const updateCardFromDeck = (deckID, cards) =>
  deckRef
    .doc(deckID)
    .set({ cards: cards }, { merge: true })
    .catch((error) => {
      console.log(
        "===================== updateCardFromDeck Error ============>>>>>>>>>",
        error
      );
      errorHandling(error);
      return error;
    });

export const deleteDeck = (deckID) => {
  return deckRef
    .doc(deckID)
    .delete()
    .catch((error) => {
      console.log(
        "===================== deleteDeck Error ============>>>>>>>>>",
        error
      );
      errorHandling(error);
      return error;
    });
};

export const loginUser = (email, password) => {
  return firebase
    .auth()
    .signInWithEmailAndPassword(email, password)
    .then((res) => {
      console.log(res.user);
      return res.user;
    })
    .catch((error) => {
      console.log(
        "===================== login Error ============>>>>>>>>>",
        error
      );
      errorHandling(error);
      return error;
    });
  // authorsRef
  //   .where("authorEmail", "==", email)
  //   .where("authorPassword", "==", password)
  //   .get();
};

export const signupUser = (email, password) => {
  return firebase
    .auth()
    .createUserWithEmailAndPassword(email, password)
    .then((res) => {
      console.log(res.user);
      console.log("res return is>>", res.user.uid);
      return res.user;
    })
    .catch((e) => {
      console.error("=============== signup Error ========>>>", e);
      errorHandling(e);
      return e;
    });
};
export const logoutUser = () =>
  firebase
    .auth()
    .signOut()
    .then(() => {
      localStorage.clear();
      return true;
    })
    .catch((error) => {
      return false;
      console.log(
        "===================== Logout Error ============>>>>>>>>>",
        error
      );
    });

export const deleteFileFromStorage = (ref) =>
  firebase
    .storage()
    .ref(ref)
    .delete()
    .catch((error) => {
      console.log(
        "===================== deleteFileFromStorage Error ============>>>>>>>>>",
        error
      );
      errorHandling(error);
      return error;
    });

export const deleteCommentRecord = (docId, comments) => {
  articleRef
    .doc(docId)
    .set({ comments: comments }, { merge: true })
    .catch((error) => {
      console.log(
        "===================== deleteCommentRecord Error ============>>>>>>>>>",
        error
      );
      errorHandling(error);
      return error;
    });
};

firebase.auth().onIdTokenChanged((user) => {
  if (!user) {
    logoutUser();
  }
});

firebase.auth().onAuthStateChanged(function (user) {
  if (user) {
    user.getIdToken().then(function (idToken) {
      console.log(idToken); // It shows the Firebase token now
    });
  }
});

export default firebase;
